module.exports = __webpack_public_path__ + "static/collected-poems-of-wb-yeats-b9b3712b0e16a6a2e66602b9a13ea1b4.jpg";